type AppConfig = {
    [key: string]: string | boolean;
};

const getEnv = (key: string, fallback: string = ""): string => {
    if (typeof window !== "undefined" && (window as any).env?.[key]) {
        return (window as any).env[key];
    }

    if (typeof process !== "undefined" && process.env[key]) {
        return process.env[key] as string;
    }

    return fallback;
};

export const CONFIG: AppConfig = {
    REACT_APP_AUTH_TENANT: getEnv("REACT_APP_AUTH_TENANT"),
    REACT_APP_AUTH_SIGNIN_NAME: getEnv("REACT_APP_AUTH_SIGNIN_NAME"),
    REACT_APP_AUTH_SIGNUP_NAME: getEnv("REACT_APP_AUTH_SIGNUP_NAME"),
    REACT_APP_AUTH_PASSWORDRESET_NAME: getEnv("REACT_APP_AUTH_PASSWORDRESET_NAME"),
    REACT_APP_AUTH_PROFILEEDIT_NAME: getEnv("REACT_APP_AUTH_PROFILEEDIT_NAME"),
    REACT_APP_AUTH_CLIENTID: getEnv("REACT_APP_AUTH_CLIENTID"),
    REACT_APP_AUTH_ENDPOINTREADSCOPE: getEnv("REACT_APP_AUTH_ENDPOINTREADSCOPE"),
    REACT_APP_AUTH_ENDPOINTWRITESCOPE: getEnv("REACT_APP_AUTH_ENDPOINTWRITESCOPE"),
    REACT_APP_AUTH_REDIRECTURL: getEnv("REACT_APP_AUTH_REDIRECTURL"),
    REACT_APP_AUTH_POSTLOGOUTURL: getEnv("REACT_APP_AUTH_POSTLOGOUTURL"),
    REACT_APP_AUTH_USE_POPUP: getEnv("REACT_APP_AUTH_USE_POPUP") === "true",
    REACT_APP_SERVER: getEnv("REACT_APP_SERVER"),
    REACT_APP_POSTECANADAKEY: getEnv("REACT_APP_POSTECANADAKEY"),
    REACT_APP_PAYSAFE_USERNAME: getEnv("REACT_APP_PAYSAFE_USERNAME"),
    REACT_APP_PAYSAFE_PASSWORD: getEnv("REACT_APP_PAYSAFE_PASSWORD"),
};
